exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-buttons[data-v-9e3202c2] {\n  margin-bottom: 15px;\n}", ""]);

// exports
